import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { notificationService } from '@/lib/services/notification.service';
import { logger } from '@/lib/utils/logger';
import { track } from '@/shared/analytics';
import { CONNECTED_APPS_QUERY_KEYS, disconnectApp } from '../api';
import type { ConnectedApp } from './types';

export const useDisconnectApp = () => {
  const { t } = useTranslation('admin');
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (app: ConnectedApp) => disconnectApp(app.id),
    onSuccess: async (_result, app) => {
      await queryClient.invalidateQueries({ queryKey: CONNECTED_APPS_QUERY_KEYS.list });
      notificationService.showSuccess(
        t('connectedApps.useDisconnectApp.wasDisconnected', { clientName: app.clientName }),
      );
      track('connected_app_disconnected', {
        client_name: app.clientName,
        scopes: app.scopes.map(({ scope }) => scope),
      });
    },
    onError: (error, app) => {
      notificationService.showError(
        t('connectedApps.useDisconnectApp.couldNotDisconnect', { clientName: app.clientName }),
      );
      logger.error('Failed to disconnect application:', error);
    },
  });
};
